import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function BatchChecklistPrint() {
  const [params] = useSearchParams();
  const storeId = params.get("store_id") || "";
  const [rows, setRows] = useState(null);
  const [storeName, setStoreName] = useState("All Branches");

  useEffect(() => {
    const qs = storeId ? `?store_id=${storeId}` : "";
    api.get(`/admin/batches${qs}`).then((r) => {
      const list = r.data.filter((b) => b.status === "expired" || b.status === "near_expiry")
        .sort((a, b) => String(a.expiry_date).localeCompare(String(b.expiry_date)));
      setRows(list);
      setTimeout(() => window.print(), 600);
    }).catch(() => setRows([]));
    if (storeId) api.get("/stores").then((r) => { const s = r.data.find((x) => x.id === storeId); if (s) setStoreName(s.name); });
  }, [storeId]);

  if (!rows) return <div style={{ padding: 40, fontFamily: "Arial" }}>Loading checklist…</div>;

  const today = new Date().toISOString().slice(0, 10);
  return (
    <div style={{ padding: "28px 32px", fontFamily: "Arial, sans-serif", color: "#111", maxWidth: 800, margin: "0 auto" }} data-testid="expiry-print">
      <style>{`@media print{.no-print{display:none!important}} table{border-collapse:collapse;width:100%} th,td{border:1px solid #cbd5e1;padding:7px 9px;font-size:13px;text-align:left} th{background:#f1f5f9} .exp{color:#dc2626;font-weight:700} .near{color:#d97706;font-weight:700}`}</style>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22 }}>Rs. Mart — Near-Expiry Checklist</h1>
          <p style={{ margin: "4px 0", color: "#475569", fontSize: 13 }}>Branch: <b>{storeName}</b> · Printed: {today}</p>
        </div>
        <button className="no-print" onClick={() => window.print()} style={{ background: "#0B8E36", color: "#fff", border: 0, borderRadius: 8, padding: "8px 14px", fontWeight: 700, cursor: "pointer" }}>Print / Save PDF</button>
      </div>
      <p style={{ fontSize: 12, color: "#64748b", marginBottom: 12 }}>Pull expired items off shelves. Tick each batch after checking.</p>
      <table>
        <thead><tr><th style={{ width: 34 }}>✓</th><th>Product</th><th>Batch</th><th>Expiry</th><th>Days</th><th>Qty</th></tr></thead>
        <tbody>
          {rows.map((b) => (
            <tr key={b.id}>
              <td style={{ textAlign: "center" }}>☐</td>
              <td>{b.product_name}</td>
              <td>{b.batch_no}</td>
              <td className={b.status === "expired" ? "exp" : "near"}>{b.expiry_date}{b.status === "expired" ? " (EXPIRED)" : ""}</td>
              <td>{b.days_to_expiry}</td>
              <td>{b.quantity}</td>
            </tr>
          ))}
          {!rows.length && <tr><td colSpan="6" style={{ textAlign: "center", color: "#64748b" }}>No expiring or expired batches 🎉</td></tr>}
        </tbody>
      </table>
      <p style={{ marginTop: 20, fontSize: 12, color: "#64748b" }}>Checked by: ____________________   Signature: ____________________</p>
    </div>
  );
}
